// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"su_a bhr_b bhr_bj","HomeBaseBanner__hint":"su_b bhr_vh","HomeBaseBanner__link":"su_c"};